import {makeAutoObservable} from "mobx";
import {IncidentsGridStore} from "areas/incidents/IncidentsGridStore";
import {apiFetch} from "framework/api";
import {getIncidentsRulesConfiguration} from "areas/incidents/IncidentsGridStore/api";
import {IncidentsGridWidgetConfig} from "areas/incidents/widgets/IncidentsGridWidget/config";
import {WidgetProps} from "controls/designer/features/widgets/widgetProps";
import {GridState} from "controls/grid/gridState";
import {IncidentsGridWidgetPersistedState} from "./persistedState";
import {deserialize} from "serializr";
import {Incident} from "areas/incidents/incident";
import {convertLegacyState} from "controls/grid/legacyGridState";
import {ExternalStateProvider} from "controls/grid/stateProviders";
import {StylesFromMxGraphCellPlugin} from "controls/grid/plugins/stylesFromMxGraphCellPlugin";


export class IncidentsGridWidgetStore{
	incidentsGridStore: IncidentsGridStore

	constructor(public props: WidgetProps<IncidentsGridWidgetConfig, IncidentsGridWidgetPersistedState>) {
		makeAutoObservable(this)

		this.init();
	}

	async init() {
		this.incidentsGridStore = new IncidentsGridStore()

		const filtersResult = await apiFetch(getIncidentsRulesConfiguration())

		if (!filtersResult.success) {
			return
		}

		let state = null
		if(this.props.persistedState) {
			if ('grid' in this.props.persistedState) {
				state = deserialize<GridState<Incident>>(GridState, this.props.persistedState.grid)
			} else if (this.props.persistedState.columns) {
				state = convertLegacyState(
					this.incidentsGridStore.getColumns(),
					this.props.persistedState,
					filtersResult.data)
			}
		}

		this.incidentsGridStore.initDefault({
			stateProviders: [new ExternalStateProvider(state)],
			doNotInitOnCreate: true
		})

		this.incidentsGridStore.gridStore.plugins.push(new StylesFromMxGraphCellPlugin(this.props.designer.store, this.props.cell))

		await this.incidentsGridStore.gridStore.init()
	}
}
